import React, { useState } from 'react'
import { useApp } from '../../context/AppContext'
import { registerCompany, sendCompanyRegEmail } from '../../services/api'

import { BUSINESS_TYPES, INDUSTRIES, INDIAN_STATES, today } from '../../utils/helpers'
import { ChevronRight, ChevronLeft, Check, Loader2 } from 'lucide-react'
import '../../styles/AuthLayout.css'

const STEPS = ['Company Info', 'Address & Contact', 'Review']
// const STEPS = ['Company Info', 'Address & Contact', 'Financial Setup', 'Review']


const validate = (step, data) => {
  const errors = {}
  if (step === 0) {
    if (!data.name?.trim()) errors.name = 'Company name is required'
    if (!data.businessType) errors.businessType = 'Please select a business type'
    // if (!data.industry) errors.industry = 'Please select an industry'
    if (data.gstin && !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(data.gstin))
      errors.gstin = 'Invalid GSTIN format'
  }
  if (step === 1) {
    if (!data.address?.trim()) errors.address = 'Address is required'
    // if (!data.state) errors.state = 'State is required'
      if (!data.phone?.trim()) {
      errors.phone = 'Phone number is required'
    } else if (!/^[6-9]\d{9}$/.test(data.phone)) {
      errors.phone = 'Enter valid 10-digit mobile number'
    }

    if (!data.email?.trim()) {
      errors.email = 'Email is required'
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      errors.email = 'Enter valid email address'
    }
  }
  // if (step === 2) {
  //   if (!data.fyStart) errors.fyStart = 'FY Start is required'
  //   if (!data.bookBeginning) errors.bookBeginning = 'Books Start date is required'
  // }
  return errors
}



export default function CompanyRegistration() {
  const { dispatch } = useApp()
  const [step, setStep] = useState(0)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showSuccessPopup, setShowSuccessPopup] = useState(false)
  const [errors, setErrors] = useState({})
  const [data, setData] = useState({
    name: '', businessType: '', industry: '', gstin: '', pan: '',
    address: '', city: '', state: '', pincode: '', country: 'India',
    phone: '', email: '', website: '',
    loginId: '', password: 'Login@123',
    fyStart: '2024-04-01', fyEnd: '2025-03-31', currency: 'INR',
    bookBeginning: today(), decimalPlaces: 2,
    gstCertificate: null, panCard: null, msmeCert: null
  })

  const set = (key, val) => setData(p => ({ ...p, [key]: val }))
  
  const setFyStart = (val) => {
    if (!val) return;
    const year = parseInt(val.slice(0, 4))
    set('fyStart', val)
    set('fyEnd', `${year + 1}-03-31`)
  }

  const searchGstin = async () => {
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/

        if (!gstRegex.test(data.gstin)) {
          setErrors(p => ({ ...p, gstin: 'Enter valid GSTIN before search' }))
          return
        }
    try {
      const gstApiUrl = process.env.REACT_APP_GST_API_URL || "https://accounts.norissolutions.in/PHP/public/api/gst/search";
      const res = await fetch(`${gstApiUrl}?gstin=${data.gstin}`)
      const rp = await res.json()
      console.log("GST API Response:", rp)

      const payload = rp.data || rp

      // Check for success or valid payload
      if (payload && (payload.lgnm || payload.tradeNam || payload.gstin)) {
        setData(p => {
          const newData = { ...p }
          newData.name = (payload.tradeNam || payload.lgnm || '').trim()
          newData.pan = payload.gstin ? payload.gstin.substring(2, 12) : ''
          newData.businessType = payload.ctb || 'Proprietorship'
          
          if (payload.pradr?.addr) {
            const addr = payload.pradr.addr
            // Combine building name/no, street and locality for address
            newData.address = [
              addr.bnm || addr.bno, 
              addr.st, 
              addr.loc,
              addr.locality
            ].filter(Boolean).join(', ')
            
            newData.city = addr.dst || addr.loc || ''
            newData.pincode = addr.pncd || ''
            newData.state = addr.stcd || ''
          }
          return newData
        })
        setErrors(p => { const newE = { ...p }; delete newE.gstin; return newE })
      } else {
        const errorMsg = rp.message || 'Could not find details for this GSTIN'
        setErrors(p => ({ ...p, gstin: errorMsg }))
      }
    } catch (err) {
      setErrors(p => ({ ...p, gstin: 'Failed to fetch GSTIN details' }))
    }
  }

  const next = () => {
    const e = validate(step, data)
    if (Object.keys(e).length > 0) { setErrors(e); return }
    setErrors({})
    setStep(s => s + 1)
  }

  const back = () => { setErrors({}); setStep(s => s - 1) }

  const handleStepClick = (idx) => {
      // Prevent going forward without validation
      if (idx > step) {
        const e = validate(step, data)
        if (Object.keys(e).length > 0) {
          setErrors(e)
          return
        }
      }

      setErrors({})
      setStep(idx)
    }

  const submit = async () => {
    for (let i = 0; i < STEPS.length - 1; i++) {
      const e = validate(i, data)
      if (Object.keys(e).length > 0) { setStep(i); setErrors(e); return }
    }

    // if (!data.email?.trim()) {
    //   errors.email = "Email is required"
    // }

    setIsSubmitting(true)
    let payload = {};
    try {
      payload = {
        // --- Core Base Fields (Mapped for both PHP schemas) ---

        Name: data.name,
        // CompanyName: data.name,
        GSTIN: data.gstin || '',
        // Address: data.address,
        Address1: data.address,
        City: data.city,
        // State: data.state || '',
        BusinessType: data.businessType || 'Proprietorship',
        Pincode: data.pincode || '',
        Country: data.country || 'India',
        
        // --- Contact & Security ---
        Contact: data.phone,
        // Phone: data.phone,
        Email: data.email,
        LoginID: data.loginId || data.phone,
        Password: data.password,
        Status: "Active",

        // // --- Metadata & Accounting ---
        // BusinessType: data.businessType || 'Proprietorship',
        // Industry: data.industry || 'Petroleum',
        // PAN: data.pan || '',
        // Website: data.website || '',
        // FinancialYearStart: data.fyStart,
        // FinancialYearEnd: data.fyEnd,
        // Currency: data.currency,
        // DecimalPlaces: Number(data.decimalPlaces),
        // BooksStartDate: data.bookBeginning,

        // // --- Required Files ---
        // GstCertificate: data.gstCertificate,
        // PanCard: data.panCard
      };

      console.log("Submitting Registration Payload:", payload);
      const resData = await registerCompany(payload);
      
      if (!resData || !resData.success) {
        throw new Error(resData?.message || 'Server returned an error');
      }


      // Send the verification/registration email
      try {
        const companyId = resData.Companyid || resData.company_id || resData.companyid || resData.id || '1';
        await sendCompanyRegEmail(data.email, data.name, companyId);
      } catch (mailErr) {
        console.error("Mail Send Error:", mailErr);
        // We don't block the UI for mail failures if registration was successful
      }

      dispatch({ type: 'SAVE_PENDING_REGISTRATION', payload: { ...data, companyId: resData.company_id || resData.id } })
      setShowSuccessPopup(true)
    } catch (err) {
      console.error("DEBUG: Registration Payload", payload);
      console.error("DEBUG: Server Response", err);
      
      let msg = err.message;
      if (msg.includes("Duplicate entry")) {
        if (msg.includes("Company.GSTIN")) {
          msg = "Registration Failed: This GSTIN ( " + (data.gstin || "") + " ) is already registered with another account. Please use a unique GSTIN or contact support.";
        } else if (msg.includes("Company.Email") || msg.includes("Email")) {
          msg = "Registration Failed: This Email Address is already registered. Please use a different email.";
        } else if (msg.includes("Company.Phone") || msg.includes("Phone")) {
          msg = "Registration Failed: This Phone Number is already registered.";
        } else {
          msg = "Registration Failed: Matches an existing record! This Company Name, GSTIN, Phone, or Login ID is already registered. Please try unique details.";
        }
      } else if (msg.includes("SQLSTATE") || msg.toLowerCase().includes("database error") || msg.includes("Invalid JSON")) {
        // Show more details for SQL errors but filter some noise
        msg = `System Error!\n------------------\n${msg.split('Stack trace')[0]}`;
      }
      alert(msg);
    } finally {
      setIsSubmitting(false)
    }
  }





  return (
    <div className="auth-page">
      <div className="auth-card" style={{ maxWidth: '680px' }}>
        <div className="auth-header">
          <div className="auth-logo">⛽</div>
          <h1 className="auth-title">Petro Genius</h1>
          <p className="auth-subtitle">Company Registration Wizard</p>
        </div>

        <div className="auth-body">
          {/* Progress Steps Headers */}
          <div style={{ display: 'flex', gap: '8px', marginBottom: '28px', justifyContent: 'center' }}>
            {STEPS.map((s, i) => (
              <div 
                key={i} 
                onClick={() => handleStepClick(i)}
                style={{
                  flex: 1, paddingBottom: '10px', textAlign: 'center', cursor: 'pointer',
                  borderBottom: i === step ? '3px solid #4CAF50' : '2px solid #f0f4f8',
                  color: i === step ? '#1a2b3c' : '#8a9db0', transition: 'all 0.3s'
                }}
              >
                <div style={{ fontSize: '9px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '2px' }}>Step {i + 1}</div>
                <div style={{ fontSize: '11.5px', fontWeight: i === step ? '800' : '600' }}>{s}</div>
              </div>
            ))}
          </div>

          <div style={{ minHeight: '300px' }}>
            <h2 className="auth-title-dark">{STEPS[step]} Settings</h2>
            <p className="auth-subtitle-dark">Fill in the details for your new petroleum station</p>
            
            {step === 0 && (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div className="auth-field" style={{ gridColumn: 'span 2' }}>
                  <label>Search by GSTIN</label>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <input className="auth-input" placeholder="15-digit GSTIN" style={{ textTransform: 'uppercase' }}
                      value={data.gstin} onChange={e => set('gstin', e.target.value.toUpperCase())} />
                    <button type="button" className="auth-btn-secondary" style={{ flex: '0 0 auto', width: 'auto', padding: '0 24px' }} onClick={searchGstin}>Search</button>
                  </div>
                  {errors.gstin && <div style={{ color: '#c53030', fontSize: '11px', marginTop: '4px' }}>{errors.gstin}</div>}
                </div>
                
                <div className="auth-field" style={{ gridColumn: 'span 2' }}>
                  <label>Company Name *</label>
                  <input className="auth-input" value={data.name} onChange={e => set('name', e.target.value)} placeholder="Full Business Name" />
                  {errors.name && <div style={{ color: '#c53030', fontSize: '11px', marginTop: '4px' }}>{errors.name}</div>}
                </div>

                <div className="auth-field">
                  <label>Business Type *</label>
                  <select className="auth-input" value={data.businessType} onChange={e => set('businessType', e.target.value)}>
                    <option value="">Select type</option>
                    {BUSINESS_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
                {/* <div className="auth-field">
                  <label>Industry *</label>
                  <select className="auth-input" value={data.industry} onChange={e => set('industry', e.target.value)}>
                    <option value="">Select industry</option>
                    {INDUSTRIES.map(i => <option key={i} value={i}>{i}</option>)}
                  </select>
                </div> */}
              </div>
            )}

            {step === 1 && (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div className="auth-field" style={{ gridColumn: 'span 2' }}>
                  <label>Address *</label>
                  <textarea className="auth-input" rows="1" value={data.address} onChange={e => set('address', e.target.value)} placeholder="Full office address" style={{ resize: 'vertical', minHeight: '42px' }} />
                  {errors.address && <div style={{ color: '#c53030', fontSize: '11px', marginTop: '4px' }}>{errors.address}</div>}
                </div>
                <div className="auth-field">
                  <label>City</label>
                  <input className="auth-input" value={data.city} onChange={e => set('city', e.target.value)} />
                </div>
                {/* <div className="auth-field">
                  <label>State *</label>
                  <select className="auth-input" value={data.state} onChange={e => set('state', e.target.value)}>
                    <option value="">Select State</option>
                    {INDIAN_STATES.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div> */}
                {/* <div className="auth-field">
                  <label>Pincode</label>
                  <input className="auth-input" value={data.pincode} onChange={e => set('pincode', e.target.value)} />
                </div> */}
                <div className="auth-field">
                  <label>Phone / Contact *</label>
                  <input className="auth-input" value={data.phone} onChange={e => {
                        const value = e.target.value.replace(/\D/g, '') // only digits
                        set('phone', value)
                        if (!data.loginId) set('loginId', value)
                      }} placeholder="10-digit mobile" />
                  {errors.phone && (
                    <div style={{ color: '#c53030', fontSize: '11px', marginTop: '4px' }}>
                      {errors.phone}
                    </div>
                  )}
                </div>

                <div className="auth-field" style={{ gridColumn: 'span 2' }}>
                  <label>Email ID</label>
                  <input type="email" className="auth-input" value={data.email} onChange={e => set('email', e.target.value)} placeholder="contact@company.com" />
                  {errors.email && (
                      <div style={{ color: '#c53030', fontSize: '11px', marginTop: '4px' }}>
                        {errors.email}
                      </div>
                    )}
                </div>
              </div>
            )}

            {/* {step === 2 && (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}> */}
                
                {/* Section A: Accounting Base */}
                {/* <div style={{ gridColumn: 'span 2', display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 0', borderBottom: '1px solid #edf2f7', marginBottom: '8px' }}>
                   <div style={{ padding: '6px', background: '#eefcf5', borderRadius: '8px', color: '#10b981' }}>💵</div>
                   <h3 style={{ fontSize: '13px', fontWeight: '800', color: '#1a2b3c', margin: 0, textTransform: 'uppercase' }}>Accounting Configuration</h3>
                </div> */}

                {/* <div className="auth-field">
                  <label>Financial Year Start *</label>
                  <input type="date" className="auth-input" value={data.fyStart} onChange={e => setFyStart(e.target.value)} />
                </div> */}
                {/* <div className="auth-field">
                  <label>Books Beginning From *</label>
                  <input type="date" className="auth-input" value={data.bookBeginning} onChange={e => set('bookBeginning', e.target.value)} />
                </div> */}
                
                {/* <div className="auth-field">
                  <label>Currency</label>
                  <select className="auth-input" value={data.currency} onChange={e => set('currency', e.target.value)}>
                    <option value="INR">INR - Indian Rupee</option>
                    <option value="USD">USD - US Dollar</option>
                    <option value="AED">AED - Dirham</option>
                  </select>
                </div> */}
                {/* <div className="auth-field">
                  <label>Decimal Places</label>
                  <select className="auth-input" value={data.decimalPlaces} onChange={e => set('decimalPlaces', e.target.value)}>
                    <option value="2">2 Decimal Places</option>
                    <option value="3">3 Decimal Places</option>
                    <option value="0">No Decimals</option>
                  </select>
                </div> */}
              {/* </div>
            )} */}


            {step === 2 && (
              <div style={{ background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px 28px' }}>
                  {[
                      { label: 'Company Name', value: data.name },
                      { label: 'GSTIN', value: data.gstin || '—' },
                      { label: 'Contact', value: data.phone },
                      { label: 'Email', value: data.email || '—' },
                      { label: 'Address', value: data.address },
                      { label: 'City', value: data.city },
                      { label: 'Status', value: data.Status || 'Active' }
                    ].map(({ label, value }) => (

                    <div key={label}>
                      <div style={{ fontSize: '9.5px', fontWeight: '800', color: '#8a9db0', textTransform: 'uppercase', marginBottom: '2px' }}>{label}</div>
                      <div style={{ fontSize: '13px', fontWeight: '700', color: '#1a2b3c' }}>{value}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div style={{ display: 'flex', justifyContent: 'stretch', marginTop: '24px', borderTop: '1px solid #edf2f7', paddingTop: '20px', gap: '12px' }}>
            <button className="auth-btn-secondary" style={{ flex: 1 }} onClick={step > 0 ? back : () => window.location.href = '/'}>
              <ChevronLeft size={18} style={{ marginRight: '6px' }} /> Back
            </button>
            <button className="auth-btn-primary" style={{ flex: 1 }} onClick={step < STEPS.length - 1 ? next : submit} disabled={isSubmitting}>
              {isSubmitting ? <Loader2 className="animate-spin" size={18} /> : (step < STEPS.length - 1 ? 'Continue' : 'Register Now')}
              {step < STEPS.length - 1 && <ChevronRight size={18} style={{ marginLeft: '6px' }} />}
            </button>
          </div>
        </div>

        <div style={{ background: '#f7fafd', padding: '12px', textAlign: 'center', fontSize: '10.5px', color: '#8a9db0', borderTop: '1px solid #edf2f7' }}>
          By registering, you agree to our <b>Terms of Service</b>
        </div>
      </div>

      {showSuccessPopup && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(30, 42, 58, 0.9)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(8px)' }}>
          <div className="auth-card" style={{ maxWidth: '420px', padding: '40px 32px', textAlign: 'center' }}>
            <div style={{ width: '70px', height: '70px', background: '#eefcf5', borderRadius: '50%', color: '#10b981', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
              <Check size={36} strokeWidth={3} />
            </div>
            <h3 style={{ fontSize: '22px', fontWeight: '900', color: '#1a2b3c', marginBottom: '8px' }}>Success!</h3>
            <p style={{ color: '#5a7286', fontSize: '14px', lineHeight: '1.5', marginBottom: '28px' }}>
              Your company has been successfully registered. Please check your email inbox to verify your account and set your password.
            </p>
            <button className="auth-btn-primary" style={{ height: '48px', width: '220px', margin: '0 auto' }} onClick={() => window.location.href = '/'}>
              Go to Login
            </button>

          </div>
        </div>
      )}
    </div>
  )
}
